import {
    FEEDBACK_SHOW_MODAL,
    FEEDBACK_HIDE_MODAL
} from '../_actions/types'

export type FeedbackAction = {
    type: string;
};

export type FeedbackState = {
    isShowingModal: boolean;
};

const initialState: FeedbackState = {
    isShowingModal: false,
};

export const reducer = (state: FeedbackState = initialState, action: FeedbackAction): FeedbackState => {
    switch (action.type) {
        case FEEDBACK_SHOW_MODAL:
            return {...state, isShowingModal: true};
        case FEEDBACK_HIDE_MODAL:
            return {...state, isShowingModal: false};
        default:
            return state;
    }
};